/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { StyleSheet, css } from 'aphrodite';
import { NavLink, withRouter } from 'react-router-dom';
import { Theme } from '../../config/theme';
import { mapStateToProps, mapDispatchToProps } from '../../utils';

const CHECK_ASSET = require('./check.svg');
const DOG_ASSET = require('./dog.svg');

class JoinContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.logoutHandler = this.performLogout.bind(this);
    this.redirectHandler = this.performRedirect.bind(this);
  }

  componentWillMount() {
    if (this.props.user.isAuthenticated) {
      this.props.history.push('/find');
    }
  }

  performLogout() {
    this.props.dispatch(logout());
    this.props.history.push('/');
  }

  performRedirect(to) {
    this.props.history.push(to);
  }

  render() {
    return (
      <div className={css(styles.container)}>
        <div className={css(styles.header_container)}>
          <div className={css(styles.links)}>
            <NavLink
              to="/join/subscription"
              className={css(styles.nav_item, styles.nav_item_active)}>
              <div className={css(styles.nav_item_num, this.props.step > 1 ? styles.nav_item_num_complete : null)}>1</div>
              Subscription
              <div className={css(styles.dog_icon, (this.props.step === 1 ? styles.dog_icon_visible : null))} />
            </NavLink>
            <NavLink
              to={this.props.step > 1 ? '/join/details' : false}
              className={css(styles.nav_item, (this.props.step > 1 ? styles.nav_item_active : null))}>
              <div className={css(styles.nav_item_num, this.props.step > 2 ? styles.nav_item_num_complete : null)}>2</div>
              My Details
              <div className={css(styles.dog_icon, (this.props.step === 2 ? styles.dog_icon_visible : null))} />
            </NavLink>
            <NavLink
              to={this.props.step > 2 ? '/join/payment' : false}
              className={css(styles.nav_item, (this.props.step > 2 ? styles.nav_item_active : null))}>
              <div className={css(styles.nav_item_num, this.props.step > 3 ? styles.nav_item_num_complete : null)}>3</div>
              Payment
              <div className={css(styles.dog_icon, (this.props.step === 3 ? styles.dog_icon_visible : null))} />
            </NavLink>
            <NavLink
              to={this.props.step > 3 ? '/join/profile' : false}
              className={css(styles.nav_item, (this.props.step > 3 ? styles.nav_item_active : null))}>
              <div className={css(styles.nav_item_num)}>4</div>
              Set up Account
              <div className={css(styles.dog_icon, (this.props.step === 4 ? styles.dog_icon_visible : null))} />
            </NavLink>
          </div>
        </div>
        {this.props.children}
      </div>
    );
  }
}

const styles = StyleSheet.create({
  container: {},
  header_container: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: Theme.white,
    borderTop: 'solid 1px #bfbfbf',
    borderBottom: 'solid 1px #bfbfbf',
    height: 107,

    ':before': {
      height: '100%',
      flexGrow: 1,
      backgroundColor: '#021a36',
      content: '""',
    },

    ':after': {
      flexGrow: 1,
      content: '""',
    },

    [Theme.mobile_query]: {
      display: 'none',
    },
  },
  title: {
    fontFamily: Theme.font_family_heading,
    fontSize: 45,
    textAlign: 'center',
    color: Theme.black,
    fontWeight: Theme.font_weight_heading,
  },
  links: {
    display: 'flex',
    maxWidth: '100%',
    width: 1070,
    height: '100%',
  },
  nav_item: {
    flexGrow: 1,
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    textTransform: 'uppercase',
    textAlign: 'center',
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    fontSize: Theme.font_size_secondary,
    letterSpacing: 1,
    color: '#bbbbbb',
    transition: 'all 500ms 500ms ease-in-out',

    ':before': {
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: -1,
      height: '100%',
      width: 0,
      backgroundColor: '#021a36',
      content: '""',
      transition: 'width 500ms 0ms',
    },
  },
  dog_icon: {
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translate(50%,-50%)',
    width: 45,
    height: 39,
    backgroundImage: `url('${DOG_ASSET}')`,
    backgroundSize: 'cover',
    opacity: 0,
  },
  dog_icon_visible: {
    opacity: 1,
  },
  nav_item_active: {
    zIndex: 2,
    color: Theme.white,

    ':before': {
      width: '100%',
    },

    ':not(.d) > div': {
      color: Theme.white,
      borderColor: Theme.white,
    },
  },
  nav_item_num: {
    position: 'relative',
    height: 28,
    width: 28,
    lineHeight: '23px',
    textAlign: 'center',
    marginBottom: 12,
    border: 'solid 2.5px #bbbbbb',
    color: '#bbbbbb',
    borderRadius: '50%',
    overflow: 'hidden',
    transition: 'all 300ms',

    ':before': {
      position: 'absolute',
      top: 0,
      left: 0,
      display: 'block',
      height: '100%',
      width: '100%',
      backgroundImage: `url(${CHECK_ASSET})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: '0 0',
      content: '""',
    },
  },
  nav_item_num_complete: {
    ':not(.d):not(.c)': { // specificity hack...
      color: 'transparent',
      borderColor: '#39b4d6',
      backgroundColor: '#39b4d6',
    },

    ':before': {
      backgroundSize: '14px 13px',
    },
  },
});

JoinContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

JoinContainer.defaultProps = {
  children: [],
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(JoinContainer));



// WEBPACK FOOTER //
// ./src/views/JoinContainer/index.js